module.exports = fox._r("images/halloween/gift-147.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/halloween/gift-147.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/halloween/gift-147.png
// module id = 348
// module chunks = 4